// extracted by mini-css-extract-plugin
export default {"content":"header_content__3NMwH","loading":"header_loading__OjjFR","spinner":"header_spinner__dhJdV"};